export var BuySellAssetControllerStages;
(function (BuySellAssetControllerStages) {
    BuySellAssetControllerStages["default"] = "default";
    BuySellAssetControllerStages["error"] = "error";
    BuySellAssetControllerStages["tokenList"] = "token list";
    BuySellAssetControllerStages["slippageConfig"] = "slippage config";
    BuySellAssetControllerStages["confirmTx"] = "confirm tx";
})(BuySellAssetControllerStages || (BuySellAssetControllerStages = {}));
export var DTAssetPageControllerStages;
(function (DTAssetPageControllerStages) {
    DTAssetPageControllerStages["loading"] = "loading";
    DTAssetPageControllerStages["results"] = "results";
    DTAssetPageControllerStages["error"] = "error";
})(DTAssetPageControllerStages || (DTAssetPageControllerStages = {}));
